import { trans } from '@flex-packages/i18n-base';
import type { ReactElement } from 'react';

export interface LocalizedTerm {
  tKey: ReturnType<typeof trans>;
  tOptions?: {
    values?: Record<string, string>;
    components?: Record<string, ReactElement>;
  };
}

export interface TermsList {
  title: LocalizedTerm;
  items: Array<LocalizedTerm>;
}

export interface TermGroup {
  title: LocalizedTerm;
  description?: LocalizedTerm;
  terms: Array<TermsList>;
}

export const get_개인정보_수집_및_이용 = ({
  customerName,
}: {
  customerName: string;
}): TermGroup => ({
  title: {
    tKey: trans(
      'recruiting.site_builder.job_description.apply.terms.privacy.title'
    ),
  },
  description: {
    tKey: trans(
      'recruiting.site_builder.job_description.apply.terms.privacy.description'
    ),
    tOptions: {
      values: { customerName },
      components: {
        // NOTE: 개인정보처리방침 링크. children(링크 텍스트)은 i18n 메시지에서 주입되어 정적 콘텐츠가 없다.
        PrivacyLink: (
          // eslint-disable-next-line jsx-a11y/anchor-has-content
          <a
            href="https://privacypolicy.flex.team"
            target="_blank"
            rel="noreferrer"
          />
        ),
      },
    },
  },
  terms: [],
});

export const get_인재풀_활용_동의 = (): TermGroup => ({
  title: {
    tKey: trans(
      'recruiting.site_builder.job_description.apply.terms.talent_pool.title'
    ),
  },
  terms: [
    {
      title: {
        tKey: trans(
          'recruiting.site_builder.job_description.apply.terms.talent_pool.summary'
        ),
      },
      items: [
        {
          tKey: trans(
            'recruiting.site_builder.job_description.apply.terms.talent_pool.purpose'
          ),
        },
        {
          tKey: trans(
            'recruiting.site_builder.job_description.apply.terms.talent_pool.collected'
          ),
        },
        {
          tKey: trans(
            'recruiting.site_builder.job_description.apply.terms.talent_pool.retention'
          ),
        },
        {
          tKey: trans(
            'recruiting.site_builder.job_description.apply.terms.talent_pool.refusal'
          ),
        },
      ],
    },
  ],
});

export const get_민감정보 = (): TermGroup => ({
  title: {
    tKey: trans(
      'recruiting.site_builder.job_description.apply.terms.sensitive.title'
    ),
  },
  terms: [
    {
      title: {
        tKey: trans(
          'recruiting.site_builder.job_description.apply.terms.sensitive.purpose.title'
        ),
      },
      items: [
        {
          tKey: trans(
            'recruiting.site_builder.job_description.apply.terms.sensitive.purpose.item'
          ),
        },
      ],
    },
    {
      title: {
        tKey: trans(
          'recruiting.site_builder.job_description.apply.terms.sensitive.collected.title'
        ),
      },
      items: [
        {
          tKey: trans(
            'recruiting.site_builder.job_description.apply.terms.sensitive.collected.item'
          ),
        },
      ],
    },
    {
      title: {
        tKey: trans(
          'recruiting.site_builder.job_description.apply.terms.sensitive.retention.title'
        ),
      },
      items: [
        {
          tKey: trans(
            'recruiting.site_builder.job_description.apply.terms.sensitive.retention.item1'
          ),
        },
        {
          tKey: trans(
            'recruiting.site_builder.job_description.apply.terms.sensitive.retention.item2'
          ),
        },
      ],
    },
    {
      title: {
        tKey: trans(
          'recruiting.site_builder.job_description.apply.terms.sensitive.refusal.title'
        ),
      },
      items: [
        {
          tKey: trans(
            'recruiting.site_builder.job_description.apply.terms.sensitive.refusal.item'
          ),
        },
      ],
    },
  ],
});
